const BASE_URL = process.env.REACT_APP_HASHNODE_BASE_URL || 'https://gql.hashnode.com';

async function hashnodeFetch(query, variables = {}) {
    const headers = {
        'Content-Type': 'application/json',
    };

    const requestBody = {
        query,
        variables: { 
            host: process.env.REACT_APP_HASHNODE_HOST_NAME, 
            ...variables 
        }
    };

    const response = await fetch(`${BASE_URL}`, {
        headers,
        method: 'POST',
        body: JSON.stringify(requestBody)
    });
    
    if (!response.ok) {
        throw new Error(`An error occurred: ${response.status} - ${response.statusText}`);
    }
    
    return response;
}

export { hashnodeFetch };